import { AccessoryProductCard } from '@/widgets/ProductCard'

import { SlideProps } from '../AccessoriesCarousel'

import styles from './Grid.module.scss'

/**
 * Accessories carousel grid view type
 * @param items
 * @param sectionName
 * @param sectionId
 * @param relatedId
 * @param location – Component location (Need for GTM)
 */
export const Grid = ({ items, sectionName, sectionId, relatedId, location }: SlideProps): JSX.Element => (
	<div className={styles.grid}>
		{Object.values(items).map(item => (
			<AccessoryProductCard
				key={item.ID}
				accessory={item}
				mainProductId={relatedId ?? 0}
				sectionId={sectionId}
				sectionName={sectionName}
				location={location}
			/>
		))}
	</div>
)
